module.exports = __webpack_public_path__ + "img/moreRank.ee9272ad.png";